import { useRecoilState } from 'recoil';
import { useFetchWrapper } from '_helpers';
import { useAlertActions, useStudentInfoAction, useStudentScoreAction } from '_actions';
import { classesAtom } from '_state';
import {currentClassAtom} from '_state'
import { classSlug } from '_helpers/normalize';
export { useClassWrapper };

function useClassWrapper(param) {
    const fetchWrapper = useFetchWrapper();
    const alertActions = useAlertActions();
    const studentInfoAction = useStudentInfoAction();
    const studentScoreAction = useStudentScoreAction();
    const [classes, setClasses] = useRecoilState(classesAtom);
    const [curClass, setCurClass_] = useRecoilState(currentClassAtom);
    async function getClassList(){
        console.log("Get class list wrapper called.");
        const response = await fetchWrapper.get("/api/classes/me", null, null);
        if (!response?.ok) return;
        try {
            const rawjson = await response.json();
            const list = rawjson.message || [];
            setClasses(list);

            const cached = getStoredCurrentClass();
            const currentId = curClass?.class_id || cached?.class_id;
            const user = JSON.parse(localStorage.getItem('userData') || 'null');
            const selected = list.find(c => c.class_id === currentId)
              || (user?.role === 'student' ? (list[0] || null) : null);

            if (!selected) {
                if (user?.role === 'student') setCurClass(null);
                return;
            }

            if (!curClass || curClass.class_id !== selected.class_id) {
                chooseClass(selected);
            } else if (JSON.stringify(curClass) !== JSON.stringify(selected)) {
                setCurClass(selected);
            }
        } catch {}
    }

    async function createClass(param, opts = {}){
        var urlencoded = new URLSearchParams();
        urlencoded.append("class_name", param);
        if (opts.is_trial) urlencoded.append("is_trial", "true");
        // Owner = KPI attribution. Only sent for trial classes, where a manager names the teacher who
        // will actually take the lesson; the server ignores it for non-managers.
        if (opts.class_teacher_id) urlencoded.append("class_teacher_id", opts.class_teacher_id);
        console.log("Create class wrapper called");
          const response = await fetchWrapper.post("/api/classes/create", "application/x-www-form-urlencoded", urlencoded);
          if (response == null) {
            console.log("No response");
          }
          response.json().then(rawjson => { 
            console.log(rawjson);
            if (rawjson.status == "Success"){
              getClassList();
            } else {
              alertActions.error("Không thể tạo lớp");
            }
          }); 
    }
    
    function getStoredCurrentClass() {
      try {
        return JSON.parse(localStorage.getItem('currentClass') || 'null');
      } catch {
        return null;
      }
    }

    function setCurClass(cls) {
      setCurClass_(cls || null);
      if (cls) {
        localStorage.setItem('currentClass', JSON.stringify(cls));
      } else {
        localStorage.removeItem('currentClass');
      }
      localStorage.removeItem("curClass");
    }

    function chooseClass(cls) {
      setCurClass(cls);
      console.log("Choosen class :", cls)
      if (cls !== undefined) {
        studentInfoAction.getStudentList(cls);
        studentScoreAction.getScoreList(cls);
      } 
  }

    async function chooseClassById(classId) {
      let response = await fetchWrapper.get("/api/classes/me", null, null);
      if (!response?.ok) return { status: 'error' };
      try { response = await response.json(); } catch { return { status: 'error' }; }
      response = response.message
      console.log(response)
      if (!Array.isArray(response)) return { status: 'error' };
      const wanted = classId == null ? null : String(classId);
      let selected = null;
      for (var myClass of response) {
        if (classId == null) {
          selected = myClass;
          break;
        }
        if (wanted === myClass.class_id || wanted === classSlug(myClass)) {
          selected = myClass;
          break;
        }
      }
      if (selected) {
        chooseClass(selected);
      } else {
        if (classId == null) setCurClass(null);
      }
      return selected
        ? { status: 'success', class: selected }
        : { status: 'not_found' };

    } 

    async function getCurrentClassTeacherInfo() {
      if (curClass) {
        let response = await fetchWrapper.get(`/api/classes/${curClass.class_id}?teacher=true`, null, null);
        if (!response?.ok) return;
        try { response = await response.json(); } catch { return; }
        return response;
      }
    }

    return {
        classes : classes,
        curClass,
        getCurrentClassTeacherInfo:getCurrentClassTeacherInfo,
        getClassList: getClassList,
        createClass: createClass,
        chooseClass: chooseClass,
		    chooseClassById,
        setCurClass
    };
}
